module.exports = __webpack_public_path__ + "static/img/pic_xfengm140@2x.c51815ee.png";